import React, { useState, useEffect } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth"; // Import Firebase Auth
import { FaBars } from "react-icons/fa";  // Import the Hamburger Menu Icon
import ProfileAvatarDropdown from "./ProfileAvatarDropdown"; // Import the dropdown component
import "./ProfileHeader.css";

const ProfileHeader = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [userName, setUserName] = useState("Your Profile"); // State for user's name with default value

  // Fetch user data from Firebase
  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setUserName(user.displayName || "Your Profile"); // Set user's name or fallback to default
      } else {
        setUserName("Your Profile"); // Fallback if user logs out
      }
    });

    return () => unsubscribe(); // Cleanup listener on component unmount
  }, []);

  const handleMenuToggle = () => {
    setIsMenuOpen((prev) => !prev); // Toggle the dropdown menu
  };

  return (
    <header className="profileHeader">
      <div className="profileHeader-left">
        <div className="avatar-container">
          {/* Replace Avatar with Hamburger Menu Icon */}
          <FaBars
            className="hamburger-menu"
            onClick={handleMenuToggle} // Toggle dropdown on click
          />
          {isMenuOpen && <ProfileAvatarDropdown />} {/* Render dropdown if menu is open */}
        </div>
        <div>
          <h1 className="profileHeader-title">{userName} </h1> {/* Dynamically fetched user name */}
          <p className="profileHeader-subtitle">Manage your account settings</p>
        </div>
      </div>

      <div className="profileHeader-right">
        <p className="profileHeader-info">Welcome Back!</p>
      </div>
    </header>
  );
};

export default ProfileHeader;
